/**
 * StickyBuyBar: mirrors the product page price/availability and triggers the
 * same checkout button as the page (Shiprocket when present).
 */
if (!customElements.get('sticky-buy-bar')) {
  customElements.define(
    'sticky-buy-bar',
    class extends HTMLElement {
      connectedCallback() {
        this.priceEl = this.querySelector('[data-sticky-price]');
        this.cta = this.querySelector('[data-sticky-cta]');
        this.ctaText = this.querySelector('.sticky-buy-bar__cta-text');
        if (!this.cta) return;

        this.setAttribute('data-active', '');

        this.cta.addEventListener('click', () => {
          // Scope to <main>: the cart drawer also contains a Shiprocket button,
          // and it appears earlier in the DOM.
          const checkout =
            document.querySelector('main .sr-headless-checkout') ||
            document.querySelector('main .shopify-payment-button__button') ||
            document.querySelector('main [name="checkout"]');
          // dispatchEvent (not .click()) — Shiprocket's inline handler runs on
          // the dispatched event with the button as its target.
          checkout?.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
        });

        document.addEventListener('change', (e) => {
          if (e.target.matches('.quantity__input, .redesign-qty__input, product-form [name="id"]')) this.sync();
        });

        const priceWrap = document.getElementById(this.dataset.priceId);
        if (priceWrap) {
          new MutationObserver(() => this.syncPrice()).observe(priceWrap, { childList: true, subtree: true });
        }

        this.sync();
      }

      sync() {
        const checkout = document.querySelector('main .sr-headless-checkout');
        const submit = document.querySelector('[id^="ProductSubmitButton-"]');
        const disabled = (checkout && checkout.disabled) || (submit && submit.disabled);
        this.cta.disabled = !!disabled;
        this.ctaText.textContent = disabled ? 'Sold out' : 'Buy now';
        this.syncPrice();
      }

      syncPrice() {
        const wrap = document.getElementById(this.dataset.priceId);
        const price =
          wrap?.querySelector('.price-item--sale') ||
          wrap?.querySelector('.price__regular .price-item--regular');
        if (price?.textContent.trim()) this.priceEl.textContent = price.textContent.trim();
      }
    }
  );
}
